import { Row, Col } from 'reactstrap';
import { PageHeader } from '../../components/PageHeader';
import { DataTable } from '../../components/DataTable';
import { KpiCard } from '../../components/KpiCard';
import { useBaseStats } from './useBaseStats';

/**
 * Produkt-Statistik Base (BaaS) — Betreiber-Sicht, nur lesend. KPI-Kacheln oben,
 * darunter die Aufschlüsselung nach Plan und Region.
 */
const fmt = new Intl.NumberFormat('de-DE');

export function NexusBaseStatsPage() {
  const stats = useBaseStats();
  const data = stats.data ?? {};
  const byPlan = data.byPlan ?? [];
  const byRegion = data.byRegion ?? [];

  return (
    <div>
      <PageHeader title="Base (BaaS)" subtitle="Produkt-Statistik — Projekte, Tenants, Buckets, Functions" />

      <Row className="g-3 mb-3">
        <Col xs="6" md="4" lg="2"><KpiCard label="Projekte" value={fmt.format(data.projects ?? 0)} /></Col>
        <Col xs="6" md="4" lg="2"><KpiCard label="DB-provisioniert" value={fmt.format(data.provisioned ?? 0)} /></Col>
        <Col xs="6" md="4" lg="2"><KpiCard label="Tenants" value={fmt.format(data.tenants ?? 0)} /></Col>
        <Col xs="6" md="4" lg="2"><KpiCard label="Buckets" value={fmt.format(data.buckets ?? 0)} /></Col>
        <Col xs="6" md="4" lg="2"><KpiCard label="Functions" value={fmt.format(data.functions ?? 0)} /></Col>
      </Row>

      <Row className="g-3">
        <Col xs={12} lg={6}>
          <div className="text-muted small text-uppercase mb-2">Nach Plan</div>
          <DataTable
            loading={stats.isLoading}
            error={stats.error}
            empty={!stats.isLoading && byPlan.length === 0}
            emptyMessage="Keine Plan-Daten."
            onRetry={() => stats.refetch()}
          >
            <thead>
              <tr>
                <th>Plan</th>
                <th className="text-end">Projekte</th>
              </tr>
            </thead>
            <tbody>
              {byPlan.map((r) => (
                <tr key={r.plan}>
                  <td className="small">{r.plan}</td>
                  <td className="text-end small">{fmt.format(r.n ?? 0)}</td>
                </tr>
              ))}
            </tbody>
          </DataTable>
        </Col>

        <Col xs={12} lg={6}>
          <div className="text-muted small text-uppercase mb-2">Nach Region</div>
          <DataTable
            loading={stats.isLoading}
            error={stats.error}
            empty={!stats.isLoading && byRegion.length === 0}
            emptyMessage="Keine Region-Daten."
            onRetry={() => stats.refetch()}
          >
            <thead>
              <tr>
                <th>Region</th>
                <th className="text-end">Projekte</th>
              </tr>
            </thead>
            <tbody>
              {byRegion.map((r) => (
                <tr key={r.region}>
                  <td className="font-monospace small">{r.region}</td>
                  <td className="text-end small">{fmt.format(r.n ?? 0)}</td>
                </tr>
              ))}
            </tbody>
          </DataTable>
        </Col>
      </Row>
    </div>
  );
}
